import { FC, useEffect, useState } from "react";
import { Auth } from "./components/Auth/Auth";
import AppRouter from "./routers/AppRouter";
import { getLang, setListConfigs } from "./helpers/userHelper";
import Cookies from "js-cookie";
import { apiURL, firebaseConfig } from "./untils/const";
import axios from "axios";
import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { IUserDetails } from "./store/interface/user";
import { emptyUser } from "./store/state/user";
import { useNavigate } from "react-router-dom";

export const AppContent: FC = () => {
  const [details, setDetails] = useState<IUserDetails>(emptyUser);
  const app = initializeApp(firebaseConfig);
  const auth = getAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const subscriber = auth.onAuthStateChanged(async (user) => {
      console.log("lisner onAuthStateChanged");
      if (user) {
        const authToken = await user.getIdToken();
        await axios
          .post(`${apiURL}/auth/getUserAuth`, {
            email: user.email,
            uid: user.uid,
          })
          .then(async (response: any) => {
            Cookies.set("idToken", response.data.token);
            const {
              accountType,
              email,
              lang,
              orgRole,
              contracts,
              flags,
              orgID,
              orgStatus,
              configs,
            } = response.data.userDetail;

            if (orgID) {
              await axios.post(
                `${apiURL}/auth/setClaim`,
                {
                  uid: user.uid,
                  orgID,
                },
                {
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                },
              );
              await user.getIdToken(true);
            }

            const formsConfigs = setListConfigs(configs);
            setDetails({
              uid: auth.currentUser!.uid,
              email: email,
              accountType: accountType,
              authenticated: true,
              flags: flags,
              lang: getLang(lang ? lang : navigator.language),
              contracts: contracts,
              loading: false,
              orgID: orgID,
              orgStatus: orgStatus,
              orgRole: orgRole,
              configs: formsConfigs,
            });
            sessionStorage.setItem(
              "lang",
              getLang(lang ? lang : navigator.language),
            );
            const isPaymentFlow = sessionStorage.getItem("paymentFlow")
              ? true
              : false;
            if (!isPaymentFlow) {
              navigate(`/`);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        setDetails({
          ...details,
          loading: false,
          lang: getLang(navigator.language),
        });
      }
    });
    return () => {
      subscriber();
    }; // unsubscribe on unmount
  }, []);

  return (
    <Auth details={details}>
      <AppRouter />
    </Auth>
  );
};
